import { useParams } from 'react-router';

import { usePageTitle } from '@/hooks/use-page-title';
import { useMe } from '@/platform/auth/use-me';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { ProfilePageShell } from '@/platform/features/profile/profile-shared';
import { profileSectionsForPath } from '@/platform/lib/profile-sections';

import { ProfileNoAccess } from './profile-no-access';

export function ProfileModulePage() {
  const { moduleSegment } = useParams<{ moduleSegment: string }>();
  const me = useMe();
  const sections = profileSectionsForPath(me.data, moduleSegment ?? '');
  const title = sections[0]?.navLabel ?? 'Profil';
  usePageTitle(`${title} · Profil`);

  if (sections.length === 0) {
    return <ProfileNoAccess />;
  }

  return (
    <ProfilePageShell>
      <PlatformPageHeader title={title} />
      <div className="space-y-6">
        {sections.map(({ id, Component }) => (
          <Component key={id} />
        ))}
      </div>
    </ProfilePageShell>
  );
}
